export const personalInfo = {
  name: 'Saqlain Mustaq Durjoy',
  shortName: 'Durjoy',
  title: 'Full Stack Engineer',
  experience: '5+',
  availableForHire: true,
  email: 'smdurjoy.cse@gmail.com',
  phone: '+8801784996428',
  location: 'Available Remotely',
  bio: 'Passionate full stack developer with over 5 years of experience building scalable web applications and robust APIs. I specialize in modern JavaScript ecosystems and cloud infrastructure, delivering end-to-end solutions for businesses worldwide. Always eager to tackle complex challenges and turn ideas into polished, production-ready products.',
};

export const navLinks = [
  { name: '_hello', to: 'hero' },
  { name: '_about', to: 'about' },
  { name: '_skills', to: 'skills' },
  { name: '_experience', to: 'experience' },
  { name: '_education', to: 'education' },
  { name: '_projects', to: 'projects' },
  { name: '_contact', to: 'contact' },
];

export const skills = {
  frontend: [
    { name: 'React', icon: 'react' },
    { name: 'Next.js', icon: 'nextjs' },
    { name: 'JavaScript', icon: 'javascript' },
    { name: 'TypeScript', icon: 'typescript' },
    { name: 'HTML5', icon: 'html5' },
    { name: 'CSS3', icon: 'css3' },
    { name: 'Tailwind CSS', icon: 'tailwindcss' },
  ],
  backend: [
    { name: 'Node.js', icon: 'nodejs' },
    { name: 'Express.js', icon: 'express' },
    { name: 'NestJS', icon: 'nestjs' },
    { name: 'PHP', icon: 'php' },
    { name: 'Laravel', icon: 'laravel' },
    { name: 'REST APIs', icon: 'api' },
    // { name: 'GraphQL', icon: 'graphql' },
  ],
  database: [
    { name: 'PostgreSQL', icon: 'postgresql' },
    { name: 'MySQL', icon: 'mysql' },
    { name: 'MongoDB', icon: 'mongodb' },
    { name: 'Redis', icon: 'redis' },
  ],
  devops: [
    { name: 'Docker', icon: 'docker' },
    { name: 'AWS', icon: 'aws' },
    { name: 'CI/CD', icon: 'cicd' },
    { name: 'Nginx', icon: 'nginx' },
    { name: 'Linux', icon: 'linux' },
    { name: 'Git', icon: 'git' },
  ],
};

export const socialLinks = [
  { name: 'github', url: 'https://github.com/smdurjoy', icon: 'github' },
  { name: 'linkedin', url: 'https://linkedin.com/in/smdurjoy', icon: 'linkedin' },
  { name: 'facebook', url: 'https://facebook.com/smdurjoy', icon: 'facebook' },
  { name: 'x', url: 'https://x.com/smdurjoy96', icon: 'x' },
  { name: 'email', url: 'mailto:smdurjoy.cse@gmail.com', icon: 'email' },
];

export const experiences = [
  {
    title: 'Full Stack Engineer',
    company: 'Sense & Respond Software LLC',
    period: 'Aug 2023 - Present',
    type: 'remote',
    description: 'Leading development of scalable microservices architecture and modern React applications. Mentoring junior developers and driving best practices across the engineering team.',
    technologies: ['Reactjs', 'Nestjs', 'Expressjs', 'TypeScript', 'AWS', 'MongoDb', 'Docker', 'Redis'],
  },
  {
    title: 'Software Engineer',
    company: 'Skylark Soft Limited',
    period: 'Oct 2021 - Jul 2023',
    type: 'onsite',
    description: 'Built and maintained complex garments ERP system using Laravel and Vuejs. Developed complex reports and dashboards for better decision making.',
    technologies: ['Laravel', 'Vuejs', 'Reactjs', 'MySQL', 'Bootstrap', 'JQuery', 'Linux'],
  },
  {
    title: 'Junior Software Engineer',
    company: 'Bissoy.com',
    period: 'Feb 2021 - Sep 2021',
    type: 'remote',
    description: 'Developed RESTful APIs with laravel lumen and database solutions in multiple projects. Worked on real-time doctor appointment system.',
    technologies: ['Node.js', 'Laravel', 'Lumen', 'Reactjs', 'MySQL', 'Bootstrap', 'JQuery'],
  },
];

export const education = [
  {
    degree: 'BSc. in Computer Science & Engineering',
    institution: 'Bangladesh University of Business & Technology (BUBT)',
    period: '2020 - 2024',
    grade: '3.74 / 4.00',
  },
  {
    degree: 'Diploma in Computer Engineering',
    institution: 'Rangpur Polytechnic Institute',
    period: '2015 - 2019',
    grade: '3.08 / 4.00',
  },
];

export const services = [
  {
    title: 'Frontend Development',
    description: 'Building responsive, performant user interfaces with React, Next.js, and modern CSS frameworks that deliver exceptional user experiences.',
    icon: 'code',
  },
  {
    title: 'API Development',
    description: 'Designing and building RESTful and GraphQL APIs with Node.js, Express, and NestJS that are scalable, secure, and well-documented.',
    icon: 'api',
  },
  {
    title: 'Cloud & DevOps',
    description: 'Deploying and managing applications on AWS with Docker, CI/CD pipelines, and infrastructure as code for reliable cloud-native solutions.',
    icon: 'cloud',
  },
  {
    title: 'Full Stack Applications',
    description: 'End-to-end development of web applications from database design to frontend polish, delivering complete production-ready products.',
    icon: 'application',
  },
  {
    title: 'Technical Consulting',
    description: 'Providing expert guidance on architecture decisions, technology selection, code reviews, and best practices for your development team.',
    icon: 'consulting',
  },
  {
    title: 'Maintenance & Support',
    description: 'Ongoing application maintenance, performance optimization, bug fixes, and feature enhancements to keep your product running smoothly.',
    icon: 'support',
  },
];

export const projects = [
  {
    title: 'Onannyas Glamour',
    description: 'Onannyas Glamour is a fully functional e-commerce platform built with Laravel, React, and Inertia.js. It features multiple local payment gateway integrations (bKash, Nagad, and more), courier API integration for seamless order delivery, product and inventory management, order tracking, and a robust admin dashboard for managing the entire store operations.',
    technologies: ['Laravel', 'Reactjs', 'Inertia.js', 'PHP', 'MySQL', 'Tailwind CSS'],
    github: '#',
    live: 'https://onannyasglamour.com',
    featured: true,
  },
  {
    title: 'Resortian',
    description: 'Resortian is a full-stack hotel booking platform for Bangladesh, built with NestJS, Prisma, PostgreSQL, and Next.js. It features real-time availability, secure JWT authentication, booking with payment integration, and a modern UI, along with a powerful admin panel for managing hotels and destinations.',
    technologies: ['Nextjs', 'Nestjs', 'TypeScript', 'PostgreSQL', 'Tailwind CSS', 'BullMQ', 'Redis', 'Prisma'],
    github: '#',
    live: 'https://resortian.netlify.app',
    featured: true,
  },
  {
    title: 'Agroventure',
    description: 'Agroventure is a modern agritech platform that connects farmers and investors through technology-driven agricultural solutions. The platform enables users to invest in real-world farming projects, ensuring transparent supply chains and sustainable growth in the agriculture sector.',
    technologies: ['Reactjs', 'Laravel', 'PHP', 'MySQL', 'Tailwind CSS'],
    github: '#',
    live: 'https://agroventure.asia',
    featured: true,
  },
  {
    title: 'Stalay',
    description: 'Stalay is a scalable backend system for a rental/booking platform, built with NestJS, Prisma, and PostgreSQL. It features JWT authentication with Google OAuth, real-time chat via Socket.io, multi-gateway payment integration (bKash & SSLCommerz), and a robust notification system powered by BullMQ and Redis. The platform supports role-based access (customer, owner, admin), booking lifecycle management, and high-performance APIs with caching and queue-based background processing.',
    technologies: ['Nextjs', 'Nestjs', 'TypeScript', 'PostgreSQL', 'Tailwind CSS', 'Socket.io', 'BullMQ', 'Redis', 'Prisma'],
    github: '#',
    live: 'https://stalay.com',
    featured: true,
  },
  {
    title: 'ATA',
    description: 'All Things API is a powerful API visualization and management platform that helps developers design, test, and document their APIs. The platform provides an intuitive interface for creating API flows, visualizing data structures, and generating comprehensive documentation.',
    technologies: ['Reactjs', 'Nestjs', 'TypeScript', 'Docker', 'MongoDB', 'AWS'],
    github: '#',
    live: 'https://ata.dev',
    featured: true,
  },
  {
    title: 'workersRUS',
    description: 'A modern job portal that connects job seekers with employers. Users can browse and search jobs by category, location, or keyword, and apply directly through the platform. Employers can post jobs, view applicants, and manage applications from a dedicated dashboard. The system streamlines the job-hunting and hiring process for both parties.',
    technologies: ['React', 'Expressjs', 'MongoDB'],
    github: '#',
    live: 'https://workersrus.netlify.app',
    featured: false,
  },
  // {
  //   title: 'DaNote',
  //   description: 'A simple note-taking application built with Reactjs and Firebase.',
  //   technologies: ['Reactjs', 'Firebase'],
  //   github: '#',
  //   live: 'https://danote.netlify.app',
  //   featured: false,
  // },
];
